import { createTheme } from "@mui/material/styles";

/**
 * AutoWBR theme — an SPB Finance flavored palette built on a deep indigo
 * primary with a teal accent. Rounded surfaces, soft shadows, and a clean
 * typographic scale give the app a calm, modern feel.
 */
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#3b3f8f",
      light: "#6366c4",
      dark: "#262a6b",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#13b5b1",
      light: "#5fe8e3",
      dark: "#008582",
      contrastText: "#ffffff",
    },
    success: { main: "#1f9d57" },
    warning: { main: "#d98a00" },
    error: { main: "#d64550" },
    info: { main: "#3b82c4" },
    background: {
      default: "#f5f6fb",
      paper: "#ffffff",
    },
    text: {
      primary: "#1c2235",
      secondary: "#5b6479",
    },
    divider: "rgba(28, 34, 53, 0.08)",
  },
  shape: {
    borderRadius: 14,
  },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h1: { fontWeight: 700, letterSpacing: "-0.02em" },
    h2: { fontWeight: 700, letterSpacing: "-0.02em" },
    h3: { fontWeight: 700, letterSpacing: "-0.01em" },
    h4: { fontWeight: 700, letterSpacing: "-0.01em" },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 600 },
    subtitle2: { fontWeight: 600 },
    button: { fontWeight: 600, textTransform: "none" },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#f5f6fb",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          border: "1px solid rgba(28, 34, 53, 0.08)",
          boxShadow:
            "0 1px 2px rgba(16, 24, 40, 0.04), 0 1px 3px rgba(16, 24, 40, 0.06)",
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 10, paddingInline: 18 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600 },
      },
    },
    MuiAppBar: {
      defaultProps: { elevation: 0 },
    },
    MuiTableCell: {
      styleOverrides: {
        head: { fontWeight: 700, color: "#5b6479" },
      },
    },
  },
});

export default theme;
